'use client'

import { AuthForm } from '../../../components/auth/AuthForm';
import { PhilaBrandLockup } from '../../../components/brand/PhilaBrandLockup';

interface SignUpPageProps {
  tenantUUID?: string;
  tenantName?: string;
}

export function SignUpPage({ tenantUUID, tenantName }: SignUpPageProps) {
  const isInvalidTenant = tenantUUID !== undefined && tenantName === undefined;

  return (
    <div className="flex min-h-screen flex-col items-center justify-center space-y-8 px-4">
      <div className="w-full max-w-[400px] space-y-6">
        {/* Logo and Tenant Name Section */}
        <div className="flex flex-col items-center space-y-4">
          {tenantUUID ? (
            <>
              {/* Phila Logo and Name */}
              <PhilaBrandLockup variant="default" />
              
              {/* Tenant Name (if valid) */}
              {tenantName ? (
                <h1 className="text-l font-semibold">{tenantName}</h1>
              ) : null}
              
              {/* Invalid tenant message (below logo, smaller) */}
              {isInvalidTenant && (
                <p className="text-sm text-destructive">Invalid group signup url</p>
              )}
            </>
          ) : (
            /* Normal signup - just Phila logo */
            <PhilaBrandLockup variant="default" />
          )}
        </div>

        {/* Auth Form */}
        <AuthForm mode="signup" useServerAction={true} tenantUUID={tenantUUID} />
      </div>
    </div>
  );
} 